import * as React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { filter } from "@/types/gallery";
import { Categories } from "@/types";
import { useTranslation } from "@/i18n/client";
import { useNomineesCtx } from "./contexts/nomination";
import GradientBorder from "../common/gradient-border";

type CategoryDropdown = {
  categories: Categories[];
  setCategory: React.Dispatch<React.SetStateAction<filter>>;
};

export function CategoryDropdown({ categories, setCategory }: CategoryDropdown) {
  function changeCategory(value: string) {
    const selectedCategory = categories.find((cat: filter) => cat.value === value);
    if (selectedCategory) {
      setCategory(selectedCategory);
    } else {
      console.warn("No category found with value:", value);
    }
  }
  const { lang } = useNomineesCtx();
  const { t } = useTranslation(lang, "nominees");
  return (
    <Select dir={lang == "en" ? "ltr" : "rtl"} onValueChange={(value) => changeCategory(value)}>
      <SelectTrigger className="w-[200px] rounded-full bg-foreground p-6 backdrop-blur-md sm:w-[240px] sm:p-6">
        <GradientBorder />
        <SelectValue className="ltr:font-opensans" placeholder={t("allNominees")} />
      </SelectTrigger>
      <SelectContent className="bg-foreground text-secondary opacity-100">
        <SelectGroup>
          {categories.map((cat: filter) => (
            <SelectItem
              className="cursor-pointer ltr:font-opensans"
              key={cat.title}
              value={cat.value}
            >
              {cat.title}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
